import React from 'react';

import {CodeValidationForm} from 'presentation/pages/public/components/CodeValidationForm';
import {PublicFlowEnum} from 'presentation/pages/public/constants/PublicFlowEnum';

export function Step3Form() {
	return <CodeValidationForm flowType={PublicFlowEnum.SIGN_UP} privateFlow={false} />;
}
